import { render, staticRenderFns } from "./EventDetailsModal.vue?vue&type=template&id=69323340&scoped=true&"
import script from "./EventDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./EventDetailsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69323340",
  null
  
)

export default component.exports